export enum PasswordChangeFieldNames {
    OLD_PASSWORD = 'oldPassword',
    NEW_PASSWORD = 'newPassword',
    CONFIRM_PASSWORD = 'confirmPassword'
}
